import { api } from '@/v2/plugins/axios';

const API_PATH = '/noon';

/**
 * Noon category + attribute API for the product editor — same contract as
 * TrendyolMarketplace, backed by NoonCategoryController (shared Marketplace* tables).
 */
export class NoonMarketplace {
	static getCategories(params = {}) {
		return api.get(`${API_PATH}/category`, { params }).then((res) => {
			const categories = res.data?.result?.categories;

			return {
				data: categories.data,
				totalRecords: categories.total,
			};
		});
	}

	// linkedMarketplaceId lets the backend ask noon which attributes are localizable —
	// those get an English AND an Arabic field, because noon tracks content completeness
	// per language and rejects a localizable value that carries no language tag.
	static getCategoryAttributes(categoryID, linkedMarketplaceId = null) {
		const params = linkedMarketplaceId ? { linked_marketplace_id: linkedMarketplaceId } : {};

		return api
			.get(`${API_PATH}/category/${categoryID}/category-attributes`, { params })
			.then((res) => {
				return {
					data: res.data?.result?.categoryAttribute,
				};
			});
	}

	/**
	 * The exact set of product images this noon account sends.
	 *
	 * An empty list is meaningful: it clears every link, and the service goes back to
	 * sending the product's own images. Nothing here creates or deletes an image — an
	 * image excluded from noon stays on the product and on every other marketplace.
	 */
	static selectProductImages(linkedMarketplaceId, productId, imageIds) {
		return api
			.post(`${API_PATH}/product-images/${linkedMarketplaceId}/select`, {
				product_id: productId,
				image_ids: imageIds,
			})
			.then((res) => res.data?.result?.image_ids ?? []);
	}

	static getAttributeValues(params, categoryID, marketplaceAttributeID) {
		return api
			.get(`${API_PATH}/category/${categoryID}/attribute/${marketplaceAttributeID}`, { params })
			.then((res) => {
				const attributeValues = res.data?.result?.attributeValues;

				return {
					data: attributeValues.data,
					totalRecords: attributeValues.total,
				};
			});
	}

	/**
	 * Force one category's attributes to be re-imported from noon.
	 *
	 * The editor no longer calls this: it used to, on every visit to the noon tab, which is
	 * what made the tab wait on noon before it could draw. A scheduled sweep keeps the stored
	 * attributes current and getCategoryAttributes fills an empty category by itself. Kept as
	 * a manual refresh for a category noon has changed in place.
	 */
	static importAttributes(categoryKey) {
		return api
			.get(`${API_PATH}/category/${categoryKey}/import-attributes`)
			.then((res) => res.data?.result);
	}
}
